module.exports = __webpack_public_path__ + "img/goqus2-app.86b7ed15.png";